import React from 'react'
import { useTranslation } from 'react-i18next'
import './somethingError.sass'

const SomethingError = () => {
    const [t] = useTranslation()
    return (
        <div className={'oopsContainer'}>
            <img src={require('./../../assets/bob-voyeur-exhibe-amateur.gif')} />
            <div className={'errorMessage'}>{t('Oops, something went wrong')}</div>
        </div>
    )
}

export default SomethingError
